import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    $goKefu(orderId = false) {
      // 全局方法的具体实现
      const { nickname = null, header =null } = this.userInfo || [];
      const { kefu } = window.config;
      let url = '';
      console.log(nickname)
      if (nickname) {
        url = `${kefu}&vavatar=${header}&vname=${nickname}`;
      } else {
        url = kefu;
      }
      if (orderId) {
        url = url + '&order_id=' + orderId;
      }
      window.location.href = url;
    },
  },
};
